
export const CONTACT_FORM_HTML = `
<div class="relative isolate py-8 px-6 pt-14 lg:px-8">
    <div class="mx-auto mt-8 max-w-screen-2xl sm:mt-12 lg:mt-16 lg:max-w-screen-xl">
        <dl class="grid grid-cols-5 gap-4">
            <dt class="relative col-span-2">
                <h2 class="mb-6 text-left text-base font-semibold leading-7 text-dr-yellow-dark">
                    C O N T A C T
                </h2>
                <h1 class="text-4xl font-bold tracking-tight pb-8 text-dr-dark sm:text-6xl">
                    Let's Connect
                </h1>
                <!-- <div class="text-2xl text-center font-bold">with</div>" -->
                <div class="logoPlaceholder lg"></div>
                <!-- <div class="socialPlaceholder lg pt-20">
                                <a href="https://www.linkedin.com/in/desteni-rivers-757618196">
                                    <img src="assets/static/ico_linkedin.png" alt="LinkedIn" class="h-8 w-auto">
                                </a>
                                <a href="https://www.linkedin.com/in/desteni-rivers-757618196">
                                    <img src="assets/static/ico_linkedin.png" alt="LinkedIn" class="h-8 w-auto">
                                </a>
                            </div> -->
            </dt>
            <dt class="relative col-span-3">
                <form class="space-y-4" id="contact-form">
                    <div class=" grid grid-cols-4 gap-4">
                        <div class="relative col-span-2">
                            <input type='text' placeholder='First name'
                                class="flex w-full rounded-md py-3 px-4 bg-slate-100 text-slate-900 text-sm border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                id="fname" />
                        </div>
                        <div class="relative col-span-2">
                            <input type='text' placeholder='Last name'
                                class="w-full rounded-md py-3 px-4 bg-slate-100 text-slate-900 text-sm border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                id="lname" />
                        </div>
                        <div class="relative col-span-2">
                            <input type='email' placeholder='Email address'
                                class="w-full rounded-md py-3 px-4 bg-slate-100 text-slate-900 text-sm border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                autocomplete="email" id="email" />
                        </div>
                        <div class="relative col-span-2">
                            <input type='tel' placeholder='Phone number (optional)'
                                class="w-full rounded-md py-3 px-4 bg-slate-100 text-slate-900 text-sm border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                autocomplete="tel" id="phone" />
                        </div>
                        <div class="relative flex items-center col-span-full">
                            <div class="flex flex-wrap gap-6 mt-4">
                                <div class="flex items-center">
                                    <input id="radio1" type="radio" name="subject" class="hidden peer" />
                                    <label for="radio1"
                                        class="relative p-0.5 flex items-center justify-center shrink-0 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white w-5 h-5 cursor-pointer border-2 border-[#011c2b] rounded-full overflow-hidden">
                                        <span class="border-[4px] border-[#011c2b] rounded-full w-full h-full"></span>
                                    </label>
                                    <p class="text-sm text-slate-600 ml-3">Request for Quote</p>
                                </div>
                                <div class="flex items-center">
                                    <input id="radio2" type="radio" name="subject" class="hidden peer" />
                                    <label for="radio2"
                                        class="relative p-0.5 flex items-center justify-center shrink-0 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white w-5 h-5 cursor-pointer border-2 border-[#011c2b] rounded-full overflow-hidden">
                                        <span class="border-[4px] border-[#011c2b] rounded-full w-full h-full"></span>
                                    </label>
                                    <p class="text-sm text-slate-600 ml-3">Book a Consultation</p>
                                </div>
                                <div class="flex items-center">
                                    <input id="radio3" type="radio" name="subject" class="hidden peer" />
                                    <label for="radio3"
                                        class="relative p-0.5 flex items-center justify-center shrink-0 peer-checked:before:hidden before:block before:absolute before:w-full before:h-full before:bg-white w-5 h-5 cursor-pointer border-2 border-[#011c2b] rounded-full overflow-hidden">
                                        <span class="border-[4px] border-[#011c2b] rounded-full w-full h-full"></span>
                                    </label>
                                    <p class="text-sm text-slate-600 ml-3">General Inquiry</p>
                                </div>
                            </div>
                        </div>
                        <div class="relative flex items-center col-span-full">
                            <textarea placeholder='Message' rows="6"
                                class="px-4 pt-3 bg-slate-100 w-full text-sm text-slate-900 border border-gray-200 focus:border-slate-900 outline-none focus:bg-transparent"
                                id="email-body"></textarea>
                        </div>
                        <button type='submit' id="btn-submit"
                            disabled class="rounded-md bg-dr-btn-dark px-3.5 py-2.5 text-sm font-semibold text-white shadow-sm disabled:opacity-50 disabled:cursor-not-allowed disabed:hover:bg-dr-btn-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-dr-btn-dark">
                            Send Email
                        </button>
                    </div>
                </form>
            </dt>
        </dl>
    </div>
</div>
`;
